export function validateCodeRegex(code) {
  // const pattern = new RegExp(`\\b[a-fA-F0-9]{${codeLength}}\\b`);
  // return pattern.test(code);
  const pattern32 = /^[a-fA-F0-9]{32}$/;
  const pattern36 = /^(bdl_|pdt_)[a-fA-F0-9]{32}$/;

  return pattern32.test(code) || pattern36.test(code);
}
